<template>
  <div>
    <div
      :style="{
        padding: '24px',
        margin: '24px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px',
      }"
    >
      <a-form-model
        ref="ruleForm"
        layout="inline"
        :model="formInline"
        @submit="handleSubmit"
        @submit.native.prevent
      >
        <a-row>
          <a-col :span="6">
            <a-form-model-item label="商品名称" prop="user">
              <a-input v-model="exchange.goodsName" placeholder="请输入">
                <a-icon
                  slot="prefix"
                  type="user"
                  style="color: rgba(0, 0, 0, 0.25)"
                />
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item>
              <a-button type="primary" @click="seach"> 查询 </a-button>
            </a-form-model-item>
            <a-form-model-item>
              <a-button style="margin-left: 10px" @click="resetForm">
               重置
              </a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>

    <a-layout-content style="margin: 0 16px">
      <div :style="{ padding: '24px', background: '#fff', minHeight: '360px' }">
        <exchangeManagementContent
          ref="aaa"
          :exchange="exchange"
        ></exchangeManagementContent>
      </div>
    </a-layout-content>
    <!-- <memberManagementContent></memberManagementContent> -->
  </div>
</template>

<script>
import exchangeManagementContent from "./exchangeManagementContent.vue";
export default {
  components: {
    exchangeManagementContent,
  },
  data() {
    return {
      exchange: {
        goodsName: "",
        limit: 10,
        page: 1,
      },
    };
  },
  methods: {
    seach() {
      this.$refs.aaa.seach();
    },
    resetForm() {
      this.$refs.aaa.getExchangeList();
      this.exchange = {};
    },
    handleChange() {},
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/marketingManagement/exchangeManagement/exchangeManagementHome.vue